module.exports = __webpack_public_path__ + "static/media/truck-photo-06.dff1d7ed.jpg";